.<template>
    <sub-page class="m-addPaper m-addImagePaper">
        <el-steps class="step-title" :active="active" finish-status="success" simple style="padding: 12px 20%;">
            <div class="click-zone" @click="toStep(0)"></div>
            <div class="click-zone" @click="toStep(1)"></div>
            <el-step :title="$t('course.addBaseInfo')" icon="el-icon-edit"></el-step>
            <el-step :title="$t('paper.startPaper')" icon="el-icon-tickets"></el-step>
        </el-steps>

        <transition enter-active-class="animated slideInRight">

            <div class="step-box step-1" v-show="active === 0">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="$i18n.locale === 'zh-CN' ? '100px': '140px'" class="paper-form">
                    <el-row class="paper-form-row">
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('paper.name')" prop="name">
                                <el-input v-model="ruleForm.name" :placeholder="$t('tip.paperName')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('paper.type')" prop="type" style="margin-bottom: 20px">
                                <el-select v-model="ruleForm.type" :placeholder="$t('tip.paperType')">
                                    <el-option label="CT" :value="3" :disabled="ctType"></el-option>
                                    <el-option label="DR" :value="4" :disabled="drType"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('paper.form')" prop="pattern">
                                <el-select v-model="ruleForm.pattern" :placeholder="$t('tip.paperForm')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in patterns"
                                            :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="paper-form-row">
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('c.knowledgePoint')" prop="knowledge">
                                <el-cascader
                                    v-model="ruleForm.knowledge"
                                    :options="knowledgeMenu['Image']"
                                    :props="cascadeProp"
                                    :placeholder="$t('tip.knowledgePoint')"
                                    :show-all-levels="false"
                                    @change="knowledgeChange"
                                    filterable
                                ></el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                                <el-select v-model="ruleForm.forLevel" collapse-tags :placeholder="$t('tip.operatorLevel')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu" :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('c.difficulty')" prop="difficulty">
                                <el-select v-model="ruleForm.difficulty" :placeholder="$t('tip.difficulty')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in difficultyDict"
                                        :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row class="paper-form-row">
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('topic.passLine')" prop="passLine">
                                <el-input-number v-model.number="ruleForm.passLine" controls-position="right" :min="0.1" :max="1" :precision="2" :step="0.1"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
                <div class="paper-method" v-if="!isEdit">
                    <h2 class="title"><span>{{$t('tip.paperGroupType')}}</span></h2>
                    <div class="choose">
                        <el-tooltip
                            v-for="item in methodInfo"
                            class="item"
                            effect="dark"
                            :content="item.tooltip"
                            placement="bottom"
                            :key="item.prop"
                            transition="el-fade-in-linear"
                        >
                            <div class="choose-item" @click="method = item.prop" :class="{'active': method === item.prop}">
                                <h3>{{item.name}}</h3>
                                <span :class="item.prop"></span>
                            </div>
                        </el-tooltip>
                    </div>
                </div>

                <div class="btn-group">
                    <el-button type="primary" @click="nextStep('ruleForm')"
                        style="padding: 14px 50px;font-size: 18px;">{{$t('c.next')}}
                    </el-button>
                </div>
            </div>
        </transition>



        <transition enter-active-class="animated slideInLeft">
            <div class="step-box step-2" v-show="active === 1">
                <component
                    :is="componentName"
                    @last-step="lastStep"
                    :passLine ="ruleForm.passLine"
                    :paperName= "ruleForm.name"
                    :type= "ruleForm.type"
                    :knowledgeName= "ruleForm.knowledge"
                    :forLevel= "ruleForm.forLevel"
                    :difficulty= "ruleForm.difficulty"
                    :pattern= "ruleForm.pattern"
                    :paperDetail="paperData"
                    :paperId="paperId"
                    :score="topicScore"
                    @needUpdate="needUpdate"
                ></component>


            </div>
        </transition>

    </sub-page>
</template>

<script>
    import SubPage from '@/components/Subpage.vue';
    import addImageByAuto from './Image/AddImageByAuto.vue'
    import addImageByManual from './Image/AddImageByManual.vue'
    import addImageByTip from './Image/AddImageByTip.vue'
    import { mapGetters } from 'vuex';
    import api from '@/api';
    import {Cascade} from '@/utils';

    export default {
        props: ['paperId','paperType'],
        data() {
            let validatePass = (rule, value, callback) => {
                if (value>1||value<0) {
                    return callback(new Error('及格线取值范围是0~1'));
                }
                callback();
            };
            return {
                active: 0,
                method: '',
                ruleForm: {
                    name:'',
                    type:'',
                    knowledge: [],
                    forLevel: '',
                    pattern:'',
                    difficulty: '',
                    passLine: 0.6,
                },
                difficultyDict: [],
                patterns: [],
                rules: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    knowledge: [
                        { required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change' }
                    ],
                    forLevel: [
                        { required: true, message: this.$t('tip.operatorLevel'), trigger: 'change' }
                    ],
                    type: [
                        { required: true, message: this.$t('tip.paperType'), trigger: 'change' }
                    ],
                    pattern: [
                        { required: true, message: this.$t('tip.paperForm'), trigger: 'change' }
                    ],
                    difficulty: [
                        {  required: true, message: this.$t('tip.difficulty'), trigger: 'change' }
                    ],
                    passLine: [
                        { type:'number',required: true, message: this.$t('tip.passLine'), trigger: 'blur' },
                        {validator: validatePass, trigger: 'blur'}
                    ],
                },
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
                ctType: false,
                drType: false,
                methodInfo: [{
                    prop: 'Auto',
                    name: this.$t('paper.buildupSmart'),
                    tooltip: this.$t('paper.randomGenPaper')
                }, {
                    prop: 'Manual',
                    name: this.$t('paper.buildupChoose'),
                    tooltip: this.$t('paper.chooseGenPaper')
                }, {
                    prop: 'Tip',
                    name: this.$t('paper.buildupFast'),
                    tooltip: this.$t('paper.tipGenPaper'),
                },],
                isEdit: false,
                paperData: [],
                topicScore: 2
            }
        },
        created() {
            this.$store.dispatch('getForLevelMenu')
            this.$store.dispatch('getKnowledgeMenu', {
                type: 'Image'
            }).then(data => {
                if(this.paperId){
                    this.isEdit=true
                    this.initData()
                }
            })

            api.getDifficulty().then(res => {
                this.difficultyDict = res.package;
            })
            api.getPaperPattern().then(res => {
                this.patterns = res.package;
            })

        },
        computed: {
            ...mapGetters([
                'forLevelMenu',
                'knowledgeMenu'
            ]),
            componentName() {
                if (this.method === 'Auto') {
                    return 'addImageByAuto'
                } else if (this.method === 'Manual') {
                    return 'addImageByManual'
                }else if (this.method === 'Tip') {
                    return 'addImageByTip'
                }
            },
        },
        methods: {
            initData() {
                let apiGet
                if(this.paperType == 3){
                    apiGet = api.getCTPaper(this.paperId)
                }else if(this.paperType == 4){
                    apiGet = api.getDRPaper(this.paperId)
                }
                apiGet.then(res => {
                    let paperData=res.package
                    this.method = 'Manual'
                    this.ruleForm.name = paperData.title;
                    this.ruleForm.knowledge = Cascade.fullPath(this.knowledgeMenu['Image'], paperData.knowledge)
                    this.ruleForm.forLevel = paperData.forLevel
                    this.ruleForm.type = paperData.type
                    this.ruleForm.pattern = paperData.form
                    this.ruleForm.difficulty = paperData.difficulty
                    this.ruleForm.passLine = paperData.passLine
                    this.topicScore=paperData.topicScore
                    this.paperData=paperData.relationship
                    this.isDisabledType()
                })
            },
            isValid() {
                let bool = true
                if (this.active === 0) {
                    this.$refs['ruleForm'].validate((valid) => {
                        if (!valid) {
                            bool = false
                            return
                        }

                        if (!this.method) {
                            this.$message({
                                message: this.$t('tip.paperGroupType'),
                                type: 'error'
                            });
                            bool = false
                        }
                        if (this.method=='Tip' && this.ruleForm.type==3) {
                            this.$message({
                                message: this.$t('tip.chooseGroupType'),
                                type: 'error'
                            });
                            bool = false
                        }
                    });
                }

                return bool
            },
            toStep(n) {
                if (this.isValid()) {
                    this.isDisabledType()
                    this.active = n
                }
            },
            lastStep() {
                this.active--
            },
            nextStep() {
                if (this.isValid()) {
                    this.isDisabledType()
                    this.active++

                }
            },

            //知识点变化
            knowledgeChange(data){
                this.ruleForm.knowledge=data;
            },
            //课件类型是否禁选
            isDisabledType(){
                if(this.ruleForm.type == 3){
                    this.ctType = false
                    this.drType = true
                }else if(this.ruleForm.type == 4){
                    this.ctType = true
                    this.drType = false
                }
            },
            closeFn() {
                if (this.paperId) {
                    this.$router.replace({name: 'myPaper'})
                    return
                }

                this.$confirm(this.$t('m.paperingOrExit'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.$router.replace({name: 'myPaper'})
                }).catch(() => {
                })
            },
            needUpdate() {
                this.$emit('needUpdate')
            }
        },

        components: {
            SubPage,
            addImageByAuto,
            addImageByManual,
            addImageByTip
        }
    }
</script>

<style lang="scss">
@import "./AddPaper";
</style>
